import React from 'react';
import './SignupSection.css';
import { useNavigate } from 'react-router-dom';

const SignupSection = () => {
  const navigate = useNavigate();

  const handleSignupClick = () => {
    navigate('/signup');
  };

  return (
    <div className="signup-section">
      <h2>Sign up now to instantly see your exclusive discounts!</h2>

      <div className="signup-button-wrapper">
        <button className="signup-cta-btn" onClick={handleSignupClick}>
          Yes! Show me today’s exclusive deals
        </button>
      </div>

      <p className="reassurance">No spam. Just incredible deals tailored for you.</p>
    </div>
  );
};

export default SignupSection;
